module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "total-methane-2020.c0f32012.png";